export default function MatchesApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getWinzEntries(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/WinzEntries/${id}`));
        });
    }

    function updateWinzEntry(id, data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/WinzEntries/${id}`, data));
        });
    }

    function reprocess(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/winzentries/reprocess/${id}`));
        });
    } 

    function createWinzEntry(data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/WinzEntries`, data));
        });
    }

    function deleteWinzEntry(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/WinzEntries/${id}`));
        });
    }

    return {
        getWinzEntries,
        updateWinzEntry,
        reprocess,
        createWinzEntry,
        deleteWinzEntry
    }

}